// extracted by mini-css-extract-plugin
export default {"titleCtaContainer":"MyTalents_titleCtaContainer__bhz40","filtersContainer":"MyTalents_filtersContainer__NjA0a","talentsList":"MyTalents_talentsList__QbeKy"};